import styled from "styled-components/macro"

export const Container = styled.div`
  height: 100%;
`
